
import React, { useEffect, useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Spinner } from '@/components/Spinner';

interface PaymentFormProps {
  email: string;
  setEmail: (email: string) => void;
  paymentError: string;
  handleSubscribe: () => void;
  isRedirecting: boolean;
}

const PaymentForm = ({
  email,
  setEmail,
  paymentError,
  handleSubscribe,
  isRedirecting
}: PaymentFormProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="email">Email (opcional)</Label>
        <Input
          id="email"
          type="email"
          placeholder="Introduce tu email para agilizar el proceso"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <p className="text-xs text-gray-500">
          Si proporcionas tu email, lo pre-rellenaremos en el formulario de pago
        </p>
      </div>
      
      {paymentError && (
        <Alert className="bg-red-50 border-red-200 text-red-800">
          <AlertTitle>Error en el proceso de pago</AlertTitle>
          <AlertDescription>{paymentError}</AlertDescription>
        </Alert>
      )}
      
      <div className="flex flex-col space-y-4">
        <Button 
          className="w-full bg-vegana-primary hover:bg-vegana-primary/90"
          onClick={handleSubscribe}
          disabled={isRedirecting}
        >
          {isRedirecting ? (
            <span className="flex items-center gap-2">
              <Spinner size="sm" /> Redirigiendo a Stripe...
            </span>
          ) : 'Comenzar'}
        </Button>
      </div>
    </div>
  );
};

export default PaymentForm;
